import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import '../pages/css/CustomSoftwareDevelopment.css';
import '../pages/css/Home.css';
import banner from '../images/offshore-banner.jpg';
import whoImg from '../images/whosection.jpg';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import OurPartner from '../pages/components/OurPartner';
import Industries from '../pages/components/Industries';
import TechStack from '../pages/components/TechStack';
import CaseStudy from '../pages/components/CaseStudy';
import ComparisonTable from '../pages/components/ComparisonTable';
import WorkSteps from '../pages/components/WorkSteps';
import ClientReviews from '../pages/components/ClientReviews';
import WorldwideCountries from '../pages/components/WorldwideCountries';
import Faq from '../pages/components/Faq';

function OffshoreDevelopment() {
    return (
        <>
            <section
                id="contact-section-page"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative', // Important for overlay
                    zIndex: 1,
                }}
            >
                {/* Overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.22)', // semi-transparent black
                        zIndex: 2,
                    }}
                ></div>

                <section className="container-fluid px-3 px-md-5 pt-2 pb-4 pb-md-5" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row g-0">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center align-items-md-start text-center text-md-start p-3 p-md-4">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.8, ease: 'easeOut' }}
                                className="w-100"
                            >
                                <h1 className="display-5 display-md-4 fw-bold title-text text-white mt-1"><span className="highlight-orange">Award-winning </span>Offshore  <span className="highlight-orange"> Software </span> Development
                                </h1>
                                <p className="mb-4 fw-semibold fs-4 text-white" style={{ maxWidth: '870px' }}>
                                    Accelerate your digital transformation with high-quality offshore development services — tailored for your enterprise growth and innovation.
                                </p>
                                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-md-start align-items-center">
                                    <button className="btn custom-orange-btn py-3 px-4 fw-bold d-flex align-items-center text-center" onClick={() => window.location.href = '/contact-us'}>
                                        Outsource software development
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </section>
            <section className="container my-5 who-section">
                <div className="row align-items-center">
                    {/* Left Box: 60% width with animation */}
                    <motion.div
                        className="col-12 col-md-7 mb-4 mb-md-0"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        <h2 className="fw-bold display-5">Why Choose
                            <span className="highlight-orange"> Peregrinee</span> for <span className="highlight-orange">Offshore </span>Software Development?
                        </h2>
                        <p className="lead mt-3">
                            At Peregrinee, we blend cutting-edge technology, industry-leading expertise, and agile methodologies to deliver superior offshore software solutions. Our dedicated teams help you achieve rapid scalability, reduce operational costs, and maintain a competitive edge in your industry.
                        </p>
                    </motion.div>

                    {/* Right Box: 40% width with animation */}
                    <motion.div
                        className="col-12 col-md-5 text-center mt-4 mt-md-0"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: false, amount: 0.6 }}
                    >
                        <img
                            src={whoImg}
                            alt="Descriptive Alt Text"
                            className="img-fluid rounded section-image"
                            style={{ maxHeight: '500px' }}
                        />
                    </motion.div>
                </div>
            </section>

            <OurPartner />
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading-first">
                        <span className="highlight-orange">Why</span> Us?
                    </div>
                </div>
            </motion.section>

            <section className="container section-mobile-top-margin my-md-5">
                <div className="row g-4">
                    {[
                        {
                            title: 'Proven Expertise',
                            description:
                                'Benefit from our experienced professionals skilled in the latest technologies and best practices, ensuring exceptional results tailored to your specific business needs.',
                        },
                        {
                            title: 'Scalable Teams',
                            description:
                                'Quickly scale up or down your development team to align perfectly with your project\'s evolving requirements, ensuring maximum efficiency and cost-effectiveness.',
                        },
                        {
                            title: 'Agile Methodology',
                            description:
                                'Our agile-driven processes ensure rapid development cycles, continuous improvements, and transparent communication at every project stage.',
                        },
                        {
                            title: 'Cost Savings',
                            description:
                                'By working with our offshore software development teams, you save on salaries, benefits packages, and overhead associated with recruiting and retaining full-time staff.',
                        },
                    ].map((item, index) => (
                        <div key={index} className="col-12 col-md-6 col-lg-3">
                            <div className="p-4 h-100 shadow rounded bg-white">
                                <h5 className="fw-bold mb-2">{item.title}</h5>
                                <p className="mb-0 text-muted small">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <Industries />
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading-first">Our
                        <span className="highlight-orange"> Offshore Software</span>  Development Services
                    </div>
                </div>
            </motion.section>

            <section className="container section-mobile-top-margin my-md-5">
                <div className="row g-4">
                    {[
                        {
                            title: 'Artificial Intelligence',
                            description:
                                'Our offshore specialists leverage advanced AI, machine learning, and data analytics technologies to enhance operational efficiency across global operations.',
                            
                        },
                        {
                            title: 'Website & Mobile App Development',
                            description:
                                'We build responsive websites and mobile apps for iOS and Android. From intuitive interfaces to robust backend systems, we ensure speed, security, and great user experience.',
                            
                        },
                        {
                            title: 'Enterprise Web Development',
                            description:
                                'We develop secure, scalable enterprise web portals using microservices architecture and modern programming tools for seamless global integration.',
                            
                        },
                        {
                            title: 'MVP Development',
                            description:
                                'We create custom MVPs with Azure cloud integration, real-time analytics, and scalable hosting to help you launch fast and grow with confidence.',
                            
                        },
                        {
                            title: 'Custom AI & Digital Solution',
                            description:
                                'We develop engaging AI-based solutions to improve user loyalty and retention through intelligent digital experiences.',
                            
                        },
                        {
                            title: 'AI Powered Development',
                            description:
                                'Integrating AI in custom software for automation, personalization, and smart decision-making — from chatbots to predictive analytics.',
                            
                        },
                        {
                            title: 'Proven Expertise',
                            description:
                                'Benefit from experts skilled in the latest technologies and best practices to deliver results tailored to your business goals.',
                        },
                        {
                            title: 'Agile Methodology',
                            description:
                                'Our agile processes ensure rapid development, constant improvements, and transparent collaboration at every stage.',
                        },
                    ].map((item, index) => (
                        <div key={index} className="col-12 col-md-6 col-lg-3">
                            <div className="p-4 h-100 shadow rounded bg-white">
                                <h5 className="fw-bold mb-2">{item.title}</h5>
                                <p className="mb-0 text-muted small">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <TechStack />
            {/* <CaseStudy /> */}
            <ComparisonTable />
            <WorkSteps />
            {/* <ClientReviews /> */}
            <WorldwideCountries />
            <Faq />

        </>
    );
};

export default OffshoreDevelopment